  // src/belediye/components/steps/PersonnelStep.js

  import { useEffect, useMemo, useRef, useState } from "react";
// FAZ-13: izin cutover'i
import usePermissions from "../../hooks/usePermissions";

  import { useDispatch, useSelector } from "react-redux";

import {
  addParticipant,
  createAssignment,
  deleteParticipant,
  fetchAssignablePersonnelByUnit,
  fetchPersonnelPanelData,
  fetchParticipantsForAssignment,
  resetAssignmentStateForNewApplication,
} from "../../redux/slices/assignmentSlice";  

  import api from "../../services/belediyeApi";

  // Heroicons
  import {
    CheckCircleIcon,
    DocumentIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
    PhotoIcon,
    UserIcon,
    ArrowDownTrayIcon,
    XCircleIcon
  } from "@heroicons/react/24/outline";
  import BasicModal from "../../components/ui/BasicModal";
  import { downloadFile } from "../../components/utils/downloadFile";

import TrDateTime from "../../components/utils/TrDateTime";
import {
  safeText,
  ensureFirstUpperTr,
  titleCaseTr,
  formatPersonNameTr,
} from "../../components/utils/textFormat";




  const MAX_RESPONDER = 3;
  const FILE_DOMAIN = "https://oys.arsuz.bel.tr/";

  /* -------------------------- yardımcı fonksiyonlar -------------------------- */

  const getAbsoluteUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    const base = FILE_DOMAIN.replace(/\/$/, "");
    const path = url.startsWith("/") ? url : `/${url}`;
    return `${base}${path}`;
  };

  const imgExt = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
  const isImage = (u) => {
    if (!u) return false;
    const parts = u.split(".");
    const ext = parts[parts.length - 1].toLowerCase();
    return imgExt.includes(ext);
  };

  /* -------------------------- ana bileşen -------------------------- */

  const PersonnelStep = ({ panelData, updatePanelData, onNext }) => {
    // FAZ-13: atama olusturma izni (uiOn=false → herkes gorur, eski davranis)
    const { uiOn, can } = usePermissions();
    const canCreateAssignment = uiOn ? can("assignments.create") : true;
    const dispatch = useDispatch();

    const { applicationData } = useSelector(
      (s) => s.belediyeApplicationDetails
    );
   const {
  assignments,
  participantsByAssignmentId,
  participantsLoadingByAssignmentId,
  participantsErrorByAssignmentId,
  loading,
  personnelPanel,
  personnelPanelLoading,
  personnelPanelError,
  assignableUsers,
  assignableUsersLoading,
  assignableUsersError,
} = useSelector((s) => s.assignment);




    const applicationId = applicationData?.id;
    const unitId = applicationData?.unit;
    const isFinalized = useMemo(
      () =>
        applicationData &&
        ["çözüldü", "çözülemedi"].includes(applicationData.status),
      [applicationData]
    );
const personnelList = useMemo(() => {
  return Array.isArray(assignableUsers)
    ? assignableUsers.filter(
        (u) =>
          u?.is_assignable === true &&
          u?.personnel_step_visible !== false &&
          u?.user_is_active !== false &&
          (
            u?.membership_is_active === null ||
            u?.membership_is_active === undefined ||
            u?.membership_is_active === true
          )
      )
    : [];
}, [assignableUsers]);

const apiError =
  personnelPanelError ||
  assignableUsersError ||
  "";
    /* ------------------------------ local state ------------------------------ */

    const [selected, setSelected] = useState(panelData?.personnel || []);
    const [responders, setResponders] = useState(panelData?.responderIds || []);
    const [note, setNote] = useState(panelData?.assignmentNote || "");
    const [lastAssignedNote, setLastAssignedNote] = useState(
    panelData?.lastAssignedNote || ""
  );

  
    const [submitError, setSubmitError] = useState("");
    const [touched, setTouched] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [refreshNonce, setRefreshNonce] = useState(0);
    



// Not “Devamını göster” için
    const [expandedNoteIds, setExpandedNoteIds] = useState(() => new Set());

    const assignmentsOrdered = useMemo(() => {
    if (!applicationId) return [];

    const list = Array.isArray(assignments) ? assignments : [];

    const filtered = list.filter((a) => {
      const appId =
        a?.application_detail?.id ?? a?.application ?? a?.application_id;
      return String(appId) === String(applicationId);
    });

    // en eski -> en yeni
    return [...filtered].sort(
      (a, b) => Number(a?.id ?? 0) - Number(b?.id ?? 0)
    );
  }, [assignments, applicationId]);

// Aynı assignmentId için tekrar tekrar fetch'i engellemek için


// assignmentsOrdered değişimlerini stabil takip etmek için

 
  const responderRequired = assignmentsOrdered.length === 0; // sadece ilk atamada zorunlu
  const assignedUserIds = useMemo(() => {
    const set = new Set();

    for (const a of assignmentsOrdered) {
      const aId = String(a?.id ?? "");
      if (!aId) continue;

      const plist = Array.isArray(participantsByAssignmentId?.[aId])
  ? participantsByAssignmentId[aId]
  : [];


      for (const p of plist) {
        if (p?.user != null) set.add(String(p.user));
      }
    }

    return set;
  }, [assignmentsOrdered, participantsByAssignmentId]);


  const latestAssignmentId = useMemo(() => {
    const last = assignmentsOrdered[assignmentsOrdered.length - 1];
    return last?.id ?? null;
  }, [assignmentsOrdered]);



    const [mediaModal, setMediaModal] = useState({ open: false, url: "", type: "image" });

const openMedia = (url, type) => {
  const abs = getAbsoluteUrl(url);
  if (!abs) return;
  setMediaModal({ open: true, url: abs, type: type === "pdf" ? "pdf" : "image" });
};

const closeMedia = () => setMediaModal({ open: false, url: "", type: "image" });

const assignmentIdsNeedingDetail = useMemo(() => {
  const ids = [];

  for (const a of assignmentsOrdered) {
    const aId = String(a?.id ?? "");
    if (!aId) continue;

    const plist = Array.isArray(participantsByAssignmentId?.[aId])
      ? participantsByAssignmentId[aId]
      : [];

    const hasFeedbackSummary = plist.some(
      (p) => p?.has_feedback || Number(p?.feedback_count || 0) > 0
    );

    if (hasFeedbackSummary) {
      ids.push(aId);
    }
  }

  return ids;
}, [assignmentsOrdered, participantsByAssignmentId]);
    // Apple-style toast
    const [toast, setToast] = useState({
      visible: false,
      type: "success", // success | error
      title: "",
      message: "",
    });

    const showToast = (type, title, message) => {
      setToast({ visible: true, type, title, message });
      setTimeout(() => {
        setToast((prev) => ({ ...prev, visible: false }));
      }, 6500); // 6–7 saniye civarı
    };

    const hideToast = () => {
      setToast((prev) => ({ ...prev, visible: false }));
    };


    /* ----------------------- feedback existence & flat list ------------------ */
  //   latest assignment’ın participant’larını store cache’inden al



// 1) Tüm assignment'ların participant'larını tek listeye indir (dedupe)
const allParticipants = useMemo(() => {
  const out = [];

  for (const a of assignmentsOrdered) {
    const aId = String(a?.id ?? "");
    if (!aId) continue;

    const plist = Array.isArray(participantsByAssignmentId?.[aId])
      ? participantsByAssignmentId[aId]
      : [];

    for (const p of plist) out.push(p);
  }

  const seen = new Set();
  return out.filter((p) => {
    const pid = String(p?.id ?? "");
    if (!pid) return false;
    if (seen.has(pid)) return false;
    seen.add(pid);
    return true;
  });
}, [assignmentsOrdered, participantsByAssignmentId]);

// 2) participant id -> participant map (feedback içinde participant id gelirse doğru kişiyi bulalım)
const participantById = useMemo(() => {
  const m = new Map();
  for (const p of allParticipants) {
    const pid = String(p?.id ?? "");
    if (pid) m.set(pid, p);
  }
  return m;
}, [allParticipants]);

// 3) Tüm feedback'leri topla, feedback id ile dedupe et, doğru participant'a bağla
const flatFeedbacks = useMemo(() => {
  const byFeedbackId = new Map();

  for (const p of allParticipants) {
    const arr = Array.isArray(p?.feedbacks) ? p.feedbacks : [];

    for (const fb of arr) {
      const fbId = fb?.id;
      if (fbId == null) continue;

      // Aynı feedback birden fazla participant objesinde görünse bile tekilleştir
      if (byFeedbackId.has(fbId)) continue;

      // feedback'in kendi participant referansı varsa onu esas al
      const fbParticipantId = String(
  fb?.participant?.id ?? fb?.participant_id ?? fb?.participant ?? ""
);


      const realParticipant =
        (fbParticipantId && participantById.get(fbParticipantId)) || p;

      byFeedbackId.set(fbId, { ...fb, participant: realParticipant });
    }
  }

  const list = Array.from(byFeedbackId.values());
  // Yeni -> eski sırala
  list.sort((a, b) => {
    const ta = Date.parse(a?.created_at ?? "") || 0;
    const tb = Date.parse(b?.created_at ?? "") || 0;
    return tb - ta;
  });

  return list;
}, [allParticipants, participantById]);

const feedbackArrived = useMemo(() => {
  return allParticipants.some(
    (p) => p?.has_feedback || Number(p?.feedback_count || 0) > 0
  );
}, [allParticipants]);



    /* ---------------- assignments & participants pull ----------------------- */

  useEffect(() => {
  if (!applicationId) return;

  dispatch(resetAssignmentStateForNewApplication(applicationId));

  // UI reset
  setSelected([]);
  setResponders([]);
  setNote("");
  setLastAssignedNote("");

 

  // Note expand reset
  setExpandedNoteIds(new Set());
}, [applicationId, dispatch]);

useEffect(() => {
  if (!applicationId || !unitId) return;

  dispatch(fetchPersonnelPanelData({ applicationId, history: true }));
  dispatch(fetchAssignablePersonnelByUnit({ unitId }));
}, [applicationId, unitId, dispatch, refreshNonce]);



useEffect(() => {
  const token = localStorage.getItem("accessToken");
  if (!token) return;

  for (const aId of assignmentIdsNeedingDetail) {
    const plist = Array.isArray(participantsByAssignmentId?.[aId])
      ? participantsByAssignmentId[aId]
      : [];

    const isLoading = !!participantsLoadingByAssignmentId?.[aId];
    const hasDetailedFeedbackData = plist.some((p) => Array.isArray(p?.feedbacks));

    if (!isLoading && !hasDetailedFeedbackData) {
      dispatch(fetchParticipantsForAssignment({ assignmentId: aId, token }));
    }
  }
}, [
  assignmentIdsNeedingDetail,
  participantsByAssignmentId,
  participantsLoadingByAssignmentId,
  dispatch,
]);

  // 4.4) Latest assignment participants fetch (üst alan + feedback stabil)
    


    /* --------------------- parent panelData ile senkron ---------------------- */

    useEffect(() => {
    updatePanelData({
      personnel: selected,
      responderIds: responders,
      assignmentNote: note,
      lastAssignedNote,
    });
  }, [selected, responders, note, lastAssignedNote, updatePanelData]);


    /* ---------------------- doğrulamalar / yardımcılar ---------------------- */

    const isPersonnelValid = () => selected.length > 0;

    const isResponderValid = () => {
    // 2. atama ve sonrası: responder zorunlu değil
    if (!responderRequired) {
      // eğer kullanıcı responder seçtiyse yine kurallara uysun (max 3 ve seçili olma)
      if (responders.length === 0) return true;
    }

    return (
      responders.length > 0 &&
      responders.length <= MAX_RESPONDER &&
      responders.every((id) => selected.includes(id))
    );
  };

    const handleSelect = (id) => {
      if (assignedUserIds.has(String(id))) {
    setSubmitError("Bu personel bu başvuruda zaten atanmış. Aynı kişiye tekrar atama yapılamaz.");
    return;
  }

      if (isFinalized) return;

      setTouched(true);
      setSubmitError("");
      

      setSelected((prev) => {
        if (prev.includes(id)) {
          // Seçimden çıkarsa responder listesinden de temizle
          if (responders.includes(id)) {
            setResponders((r) => r.filter((x) => x !== id));
          }
          return prev.filter((x) => x !== id);
        }
        return [...prev, id];
      });
    };


    const toggleResponder = (id) => {
      if (isFinalized) return;

      if (!selected.includes(id)) return;

      setTouched(true);
      setSubmitError("");

      setResponders((prev) => {
        if (prev.includes(id)) {
          // Yetkiliyi kaldır
          return prev.filter((x) => x !== id);
        }
        if (prev.length >= MAX_RESPONDER) {
          setSubmitError(
            `En fazla ${MAX_RESPONDER} yetkili seçebilirsiniz.`
          );
          return prev;
        }
        return [...prev, id];
      });
    };

    const handleDeselect = (id) => {
      if (isFinalized) return;

    
      setSelected((prev) => prev.filter((x) => x !== id));
      setResponders((prev) => prev.filter((x) => x !== id));
    };

    const sortedPersonnel = useMemo(() => {
      if (!Array.isArray(personnelList)) return [];
      return [...personnelList].sort((a, b) => {
        const aIsResponder = responders.includes(a.id);
        const bIsResponder = responders.includes(b.id);
        const aIsSelected = selected.includes(a.id);
        const bIsSelected = selected.includes(b.id);

        if (aIsResponder !== bIsResponder) {
          return aIsResponder ? -1 : 1;
        }
        if (aIsSelected !== bIsSelected) {
          return aIsSelected ? -1 : 1;
        }
        const aName = `${a.first_name || ""} ${a.last_name || ""}`.trim();
        const bName = `${b.first_name || ""} ${b.last_name || ""}`.trim();
        return aName.localeCompare(bName, "tr");
      });
    }, [personnelList, selected, responders]);

    const hasNoPersonnel = personnelList.length === 0;
const showBlockingLoader =
  submitting ||
  (personnelPanelLoading && assignmentsOrdered.length === 0) ||
  (assignableUsersLoading && personnelList.length === 0);
  

    /* --------------------------- atama işlemi --------------------------- */

    const handleAssign = async () => {
    if (isFinalized) return;

    setTouched(true);
    setSubmitError("");

    if (!isPersonnelValid()) {
      setSubmitError("Lütfen en az bir personel seçiniz.");
      return;
    }
    const dup = selected.filter((uid) => assignedUserIds.has(String(uid)));
  if (dup.length > 0) {
    setSubmitError("Seçtiğiniz personellerden bazıları bu başvuruda daha önce atanmış. Aynı kişiye tekrar atama yapılamaz.");
    setSubmitting(false);
    return;
  }


    if (responderRequired && !isResponderValid()) {
      setSubmitError(
        "İlk atamada en az 1 yetkili seçmelisiniz. (Yetkili 1–3 kişi olabilir ve seçili personellerden oluşmalıdır.)"
      );
      return;
    }

    // 2. atama ve sonrası: responder seçilmişse kurala uysun
    if (!responderRequired && responders.length > 0 && !isResponderValid()) {
      setSubmitError(
        `Yetkili sayısı en fazla ${MAX_RESPONDER} olmalı ve seçili personellerden oluşmalıdır.`
      );
      return;
    }

    setSubmitting(true);
    const token = localStorage.getItem("accessToken");

    try {
      // Her seferinde yeni assignment
      const assignedTo = responders?.[0] ?? selected?.[0];

      const created = await dispatch(
        createAssignment({
          application: applicationId,
          assigned_to: assignedTo,
          note,
          token,
        })
      ).unwrap();

      const assignmentId = created.id;

      // Backend otomatik participant eklemiş mi?
      
const existingPayload = await dispatch(
  fetchParticipantsForAssignment({ assignmentId, token })
).unwrap();

const existingList = Array.isArray(existingPayload?.list)
  ? existingPayload.list
  : [];

      
      const existingUserIds = new Set(existingList.map((p) => String(p.user)));
      const selectedSet = new Set(selected.map((x) => String(x)));

      // Seçili ama backend'de yoksa ekle
      const toAdd = selected.filter((uid) => !existingUserIds.has(String(uid)));
      for (const uid of toAdd) {
        await dispatch(
          addParticipant({
            assignment: assignmentId,
            user: uid,
            is_responder: responders.includes(uid),
            token,
          })
        ).unwrap();
      }

      // Seçili olmayan ama backend'in otomatik eklediğini sil
      for (const p of existingList) {
        const uid = String(p?.user);
        if (uid && !selectedSet.has(uid)) {
          await dispatch(
            deleteParticipant({
              participantId: p.id,
              assignmentId,
              token,
            })
          ).unwrap();
        }
      }

      // Bu assignment'ın participants’ını yenile (latest olarak da kalacak)
    await dispatch(fetchParticipantsForAssignment({ assignmentId, token }));
await dispatch(fetchPersonnelPanelData({ applicationId, history: true }));


      // UI reset
      setNote("");
      setSelected([]);
      setResponders([]);
      setTouched(false);
      setSubmitError("");

      showToast(
        "success",
        "Atama tamamlandı",
        "Atama başarıyla gerçekleştirildi. Tekrar atama yapmak isterseniz aynı adımları kullanabilirsiniz."
      );
    } catch (err) {
      setSubmitError(
        typeof err === "string"
          ? err
          : err?.message || "Atama işlemi başarısız oldu."
      );
      showToast("error", "Atama başarısız", "Atama sırasında bir hata oluştu.");
    } finally {
      setSubmitting(false);
    }
  };

    const handleNext = () => {
      // Eğer hiç personel yoksa, bu adımı atlamaya izin ver
      if (hasNoPersonnel) {
        onNext?.();
        return;
      }

      // İş mantığını bozmamak için mevcut kısıt:
      // Finalize edilmemiş + assignment yok + feedback yok ise izin verme
      
      onNext?.();
    };

    /* ------------------------ dosya önizleme modalı ------------------------ */

    

    /* -------------------------------- render -------------------------------- */

    return (
      <div className="ps-root">
        {/* Toast */}
        <div
          className={`ps-toast ${
            toast.visible ? "ps-toast--visible" : ""
          } ${
            toast.type === "success"
              ? "ps-toast--success"
              : "ps-toast--error"
          }`}
        >
          <div className="ps-toast-icon">
            {toast.type === "success" ? (
              <CheckCircleIcon />
            ) : (
              <XCircleIcon />
            )}
          </div>
          <div className="ps-toast-text">
            <div className="ps-toast-title">{toast.title}</div>
            <div className="ps-toast-message">{toast.message}</div>
          </div>
          <button
            type="button"
            className="ps-toast-close"
            onClick={hideToast}
          >
            ×
          </button>
        </div>

        {/* Başlık */}
        <div className="ps-header">
          <div className="ps-header-left">
            {/* Icon kaldırıldı */}
            <h4 className="ps-header-title">Personel Atama</h4>
          </div>
          <div className="ps-header-right">
   <button
     type="button"
     className="ps-button ps-button-secondary"
     onClick={() => setRefreshNonce((n) => n + 1)}
     disabled={submitting}
   >
     Yenile
   </button>
 </div>
        </div>

        {/* Bilgi kutusu */}
        <div className="ps-info-box">
          <div className="ps-info-icon">
            <InformationCircleIcon />
          </div>
          <div className="ps-info-text">
            <div>Başvuruyla ilgilenecek personelleri seçin.</div>
            <div>
              <strong>En az 1</strong> personel seçmelisiniz. Yetkili kişi
              sayısı <strong>1–3</strong> olmalıdır.
            </div>
          </div>
        </div>

        {/* API hatası */}
        {apiError && (
          <div className="ps-alert ps-alert--error">{apiError}</div>
        )}
        
  

  {assignmentsOrdered.length > 0 && (
    <div className="ps-assignment-history">
      <div className="ps-history-title">Atamalar</div>

      {assignmentsOrdered.map((a, idx) => {
        const aId = String(a?.id ?? "");
        if (!aId) return null;

        const isLoading = !!participantsLoadingByAssignmentId?.[aId];
        const err = participantsErrorByAssignmentId?.[aId];
        const plist = Array.isArray(participantsByAssignmentId?.[aId])
  ? participantsByAssignmentId[aId]
  : [];

        const isLast = idx === assignmentsOrdered.length - 1;

        return (
          <div key={aId} className="ps-history-card">
            <div className="ps-history-header">
              <div className="ps-history-header-left">
                <div className="ps-history-step">
                  {idx + 1}. Atama
                  {isLast && (
                    <span style={{ marginLeft: 8, fontSize: 12, opacity: 0.75 }}>
                      • Son yapılan atama
                    </span>
                  )}
                </div>
                {(() => {
  const aId = String(a?.id ?? "");
  const rawNote = safeText(a?.note, "").trim();
const noteText = rawNote ? ensureFirstUpperTr(rawNote) : "";

  const isExpanded = expandedNoteIds.has(aId);
  const canToggle = noteText.length >= 140;

  return (
    <div className="ps-history-note">
      <div className="ps-history-note-head">
        <span className="ps-history-note-label">Atama notu</span>

        {canToggle && (
          <button
            type="button"
            className="ps-history-note-toggle"
            onClick={() => {
              setExpandedNoteIds((prev) => {
                const next = new Set(prev);
                if (next.has(aId)) next.delete(aId);
                else next.add(aId);
                return next;
              });
            }}
          >
            {isExpanded ? "Kısalt" : "Devamını göster"}
          </button>
        )}
      </div>

      <div
        className={`ps-history-note-text ${
          !isExpanded && canToggle ? "ps-history-note-text--clamped" : ""
        }`}
      >
        {noteText || "Not yok"}

      </div>
    </div>
  );
})()}

              </div>

              <div className="ps-history-header-right">
                {isLoading ? "Yükleniyor..." : `${plist.length} kişi`}
              </div>
            </div>

            <div className="ps-history-body">
              {err && <div className="ps-alert ps-alert--error">{err}</div>}

              {isLoading && plist.length === 0 && (
                <div className="ps-empty-text">Katılımcılar yükleniyor...</div>
              )}

              {!isLoading && plist.length === 0 && (
                <div className="ps-empty-text">Katılımcı bulunamadı.</div>
              )}

              {plist.length > 0 && (
                <div className="ps-selected-chips ps-selected-chips--locked">
                  {plist.map((p) => {
                    const uId = String(p?.user ?? "");
                    const fullName = p?.user_detail
  ? formatPersonNameTr(p.user_detail)              // Title case + fallback
  : `Kullanıcı #${uId || "—"}`;


                    return (
                      <div
                        key={`${aId}-${p?.id}`}
                        className={`ps-chip ${p?.is_responder ? "ps-chip--responder" : ""}`}
                      >
                        <span className="ps-chip-name">{fullName}</span>
                        {p?.is_responder && <span className="ps-chip-tag">Yetkili</span>}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  )}






        {/* Seçili personellerin chip görünümü */}
        {selected.length > 0 && (
          <div className="ps-selected-chips">
            {selected.map((id) => {
              const p = personnelList.find((u) => u.id === id);
              if (!p) return null;
              const isResp = responders.includes(id);
              const fullName = formatPersonNameTr(p);

              return (
                <div
                  key={id}
                  className={`ps-chip ${
                    isResp ? "ps-chip--responder" : ""
                  }`}
                >
                  <span className="ps-chip-name">{fullName}</span>
                  {isResp && (
                    <span className="ps-chip-tag">Yetkili</span>
                  )}
                  <button
                    type="button"
                    className="ps-chip-close"
                    onClick={() => handleDeselect(id)}
                  >
                    ×
                  </button>
                </div>
              );
            })}
          </div>
        )}

        {/* Personel listesi */}
        <div
          className="ps-person-list"
          style={{ maxHeight: 260, overflowY: "auto" }}
        >
         {personnelList.length === 0 && !loading && (
  <div className="ps-empty-text">
    Bu birimde atanabilir aktif personel bulunamadı.
  </div>
)}

          {sortedPersonnel.map((p) => {
            const id = p.id;
            const isSelected = selected.includes(id);
            const isResp = responders.includes(id);
            const alreadyAssigned = assignedUserIds.has(String(id));
  const isDisabledRow = isFinalized || submitting || alreadyAssigned;

            const fullName = formatPersonNameTr(p);


            return (
              <div
    key={id}
    className={`ps-person-row
  ${isSelected ? "ps-person-row--selected" : ""}
  ${isDisabledRow ? "ps-person-row--disabled" : ""}
`}
  onClick={() => {
    if (isDisabledRow) return;
    handleSelect(id);
  }}  // ← TÜM SATIR TIKLANABİLİR
  >
    {/* Sol taraf — avatar + isim */}
    <div className="ps-person-main">
      <div className="ps-person-avatar">
        <UserIcon />
      </div>
      <div className="ps-person-text">
        <div className="ps-person-name">{fullName}</div>
        <div className="ps-person-meta">
  <span className="ps-tag">
  {p.effective_role_in_unit === "saha_personeli"
    ? "Saha personeli"
    : "Personel"}
</span>
         {p.position && (
  <span className="ps-person-position">
    {ensureFirstUpperTr(safeText(p.position, ""))}
  </span>
)}

          {alreadyAssigned && (
    <span className="ps-tag" style={{ marginLeft: 8, opacity: 0.75 }}>
      Zaten atanmış
    </span>
  )}

        </div>
      </div>
    </div>

    {/* Sağ taraf — seçim çemberi + yetki butonu */}
    <div className="ps-person-actions">
      {/* ÇEMBER: artık ayrı onClick yok, sadece görsel */}
      <button
        type="button"
        className="ps-checkbox-button"
        disabled={isDisabledRow}
        onClick={(e) => {
          e.stopPropagation();       // ← çembere tıklayınca da satır mantığı bozulmasın
          handleSelect(id);
        }}
      >
        <span
          className={`ps-checkbox-box ${
            isSelected ? "ps-checkbox-box--checked" : ""
          }`}
        >
          {isSelected && <CheckCircleIcon />}
        </span>
      </button>

      {isSelected && (
        <button
          type="button"
          className={`ps-responder-pill ${
            isResp ? "ps-responder-pill--active" : ""
          }`}
          disabled={
    isDisabledRow ||
    feedbackArrived ||
    (responders.length >= MAX_RESPONDER && !isResp)
  }

          onClick={(e) => {
            e.stopPropagation();     // ← Yetki ver’e tıklayınca satır seçimini tetiklemesin
            toggleResponder(id);
          }}
        >
          {isResp ? "Yetkili" : "Yetki ver"}
        </button>
      )}
    </div>
  </div>

            );
          })}
        </div>

        {/* Validasyon uyarıları */}
        {touched && !isPersonnelValid() && !hasNoPersonnel && (
          <div className="ps-alert ps-alert--error">
            Lütfen en az bir personel seçiniz.
          </div>
        )}
        {touched && responderRequired && !isResponderValid() && !hasNoPersonnel && (
    <div className="ps-alert ps-alert--error">
      İlk atamada en az 1 yetkili seçmelisiniz. Yetkili sayısı 1–3 olmalıdır.
    </div>
  )}

        {submitError && (
          <div className="ps-alert ps-alert--error">{submitError}</div>
        )}

        {/* Atama notu — personel yoksa göstermeyelim */}
        {!hasNoPersonnel && (
          <div className="ps-note-box">
            <label className="ps-note-label">
              Atama Notu (isteğe bağlı)
            </label>
            <textarea
              className="ps-note-textarea"
              rows={2}
              disabled={isFinalized}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Atama ile ilgili iç notunuzu yazın (isteğe bağlı)."
            />
          </div>
        )}

        {/* Geri bildirimler */}
        {flatFeedbacks.length > 0 && (
          <div className="ps-feedback-section">
            <h5 className="ps-feedback-title">Geri Bildirimler</h5>
            {flatFeedbacks.map((fb) => {
              const status = fb.status;
              const isSuccess = status === "success";
              const isFailure = status === "failure";
              const isPending = status === "pending";

              let statusLabel = "Durum yok";
              if (isSuccess) statusLabel = "Başarılı";
              else if (isFailure) statusLabel = "Başarısız";
              else if (isPending) statusLabel = "Beklemede";

              return (
                <div key={fb.id} className="ps-feedback-card">
                  <div className="ps-feedback-header">
                    <div className="ps-feedback-status">
                      <span
                        className={`ps-feedback-status-icon ${
                          isSuccess
                            ? "ps-feedback-status-icon--success"
                            : isFailure
                            ? "ps-feedback-status-icon--error"
                            : isPending
                            ? "ps-feedback-status-icon--pending"
                            : ""
                        }`}
                      >
                        {isSuccess && <CheckCircleIcon />}
                        {isFailure && <XCircleIcon />}
                        {isPending && <ExclamationTriangleIcon />}
                      </span>
                      <span className="ps-feedback-status-text">
                        {statusLabel}
                      </span>
                    </div>
                    <div className="ps-feedback-meta">
                      <span>{formatPersonNameTr(fb.created_by)}</span>

{fb.participant?.user_detail && (
  <>
    <span className="ps-feedback-dot">•</span>
    <span className="ps-feedback-participant">
      {formatPersonNameTr(fb.participant.user_detail)}
    </span>
  </>
)}

                    </div>
                  </div>

                 {fb.note && (
  <div className="ps-feedback-note">
    {ensureFirstUpperTr(safeText(fb.note, ""))}
  </div>
)}


                  {fb.file_urls && fb.file_urls.length > 0 && (
                    <div className="ps-feedback-files">
                      {fb.file_urls.map((u) => {
                        const abs = getAbsoluteUrl(u);
                        const image = isImage(abs);

                        return (
                          <button
                            key={u}
                            type="button"
                            className="ps-file-thumb"
                            onClick={() => openMedia(abs, image ? "image" : "pdf")}

                          >
                              <div className="ps-file-thumb-icon">
                              {image ? <PhotoIcon /> : <DocumentIcon />}
                            </div>
                            <div className="ps-file-thumb-name">
                              Dosya
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* Atama / İleri butonları — FAZ-13: "Atama Yap" assignments.create iznine bagli */}
        <div className="ps-actions">
          {canCreateAssignment && (
          <button
            type="button"
            className="ps-button ps-button-primary"
            disabled={
  hasNoPersonnel ||
  isFinalized ||
  submitting ||
  !isPersonnelValid() ||
  (responderRequired ? !isResponderValid() : false)
}


            onClick={handleAssign}
          >
            {submitting ? "Atama Yapılıyor..." : "Atama Yap"}
          </button>
          )}

          <button
            type="button"
            className="ps-button ps-button-secondary"
            onClick={handleNext}
          >
            İleri
          </button>
        </div>

        {/* Dosya önizleme modalı */}
        <BasicModal
  open={mediaModal.open}
  title={mediaModal.type === "pdf" ? "Belge" : "Görsel"}
  onClose={closeMedia}
  actions={
    mediaModal.url ? (
      <>
        <a
          className="btn-md btn-md-ghost"
          href={mediaModal.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Yeni sekmede aç
        </a>

        <button
          type="button"
          className="btn-md btn-md-primary"
          onClick={() =>
            downloadFile(mediaModal.url, {
              token: localStorage.getItem("accessToken"),
              filename: mediaModal.type === "pdf" ? "belge.pdf" : "gorsel.jpg",
            })
          }
        >
          <ArrowDownTrayIcon width={18} height={18} />
          İndir
        </button>
      </>
    ) : null
  }
>
  {mediaModal.type === "pdf" ? (
    <iframe title="PDF" src={mediaModal.url} className="md-modal-iframe" />
  ) : (
    <img src={mediaModal.url} alt="Önizleme" className="md-modal-image" />
  )}
</BasicModal>

        
        {showBlockingLoader && (
  <div className="ps-loading-overlay">
    <div className="ps-loading-spinner" />
  </div>
)}

      </div>
    );
  };

  export default PersonnelStep;
